import { getProfileMeUrl } from './profile';

// TODO: Move to its own file
export const PROFILE_ME_URL = getProfileMeUrl();

export const BASE_URL = '/api';
